"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var OrderSupplierController = /*#__PURE__*/function (_PageController) {
  function OrderSupplierController() {
    var _this2;
    _classCallCheck(this, OrderSupplierController);
    _this2 = _callSuper(this, OrderSupplierController);
    _this2.supplierNameEl = '.supplier-name';
    _this2.supplierNameTextEl = 'input[name="supplier_name_text"]';
    _this2.supplierEmailEl = 'input[name="supplier_contact_person_email"]';
    _this2.supplierPhoneNumberEl = 'input[name="supplier_contact_person_phone_number"]';
    _this2.supplierFirstNameEl = 'input[name="supplier_contact_person_first_name"]';
    _this2.supplierLastNameEl = 'input[name="supplier_contact_person_last_name"]';
    _this2.supplierICEl = 'input[name="supplier_ic"]';
    _this2.supplierDICEl = 'input[name="supplier_dic"]';
    _this2.supplierStreetEl = 'input[name="supplier_street"]';
    _this2.supplierCityEl = 'input[name="supplier_city"]';
    _this2.supplierPostNumberEl = 'input[name="supplier_post_number"]';
    _this2.supplierPostCountryEl = 'input[name="supplier_country"]';
    _this2.updateListOfSupplierBasedOnSearchTerm();
    return _this2;
  }
  _inherits(OrderSupplierController, _PageController);
  return _createClass(OrderSupplierController, [{
    key: "updateListOfSupplierBasedOnSearchTerm",
    value: function updateListOfSupplierBasedOnSearchTerm() {
      var _this = this;
      var select2 = $(_this.supplierNameEl).select2({
        tags: true,
        selectOnBlur: true,
        templateResult: function templateResult(state) {
          if (state.loading) {
            return state.text;
          }
          if ('name' in state) {
            var $state = $('<span style="line-height: 1.2"><strong>' + state.name + '</strong> (IČ:' + state.ic + ')<br>' + 'Adresa:' + state.street + ", " + state.city + ", " + state.post_number + '</span>');
          } else {
            var $state = $('<span>' + state.text + '</span>');
          }
          return $state;
        },
        ajax: {
          delay: 250,
          url: updateSupplierListBaseOnSearchTermUrl,
          data: function data(params) {
            return {
              searchTerm: params.term
            };
          },
          contentType: "application/x-www-form-urlencoded;charset=utf-8",
          processResults: function processResults(data) {
            return {
              results: data
            };
          }
        }
      });
      select2.on("select2:select", function (e) {
        var data = e.params.data;
        $(_this.supplierEmailEl).val(data.contact_person_email);
        $(_this.supplierNameTextEl).val(data.text);
        $(_this.supplierPhoneNumberEl).val(data.contact_person_phone_number);
        $(_this.supplierFirstNameEl).val(data.contact_person_first_name);
        $(_this.supplierLastNameEl).val(data.contact_person_last_name);
        $(_this.supplierICEl).val(data.ic);
        $(_this.supplierDICEl).val(data.dic);
        $(_this.supplierStreetEl).val(data.street);
        $(_this.supplierCityEl).val(data.city);
        $(_this.supplierPostNumberEl).val(data.post_number);
        $(_this.supplierPostCountryEl).val(data.country);
      });
    }
  }]);
}(PageController);